import React, { useEffect, useState } from "react";
import ApexChart from "react-apexcharts";
import { apexPieChartDefaultOption } from "constants/ChartConstant";
import { cloneDeep } from "lodash";

const DonutChart = ({ series, labels, colors, height }) => {
  const [options, setOptions] = useState(apexPieChartDefaultOption);

  useEffect(() => {
    const newOptions = cloneDeep(apexPieChartDefaultOption);

    // Set labels
    newOptions.labels = labels;

    // Set colors if provided
    if (colors) {
      newOptions.colors = colors;
    }

    // Configure for percentage display in tooltip
    newOptions.tooltip = {
      y: {
        formatter: function (value) {
          // Bereken percentage handmatig
          const total = series.reduce((a, b) => a + b, 0);
          const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
          return `${value} (${percentage}%)`;
        },
      },
    };

    // Show legend
    newOptions.legend = {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
    };

    // Make donut thicker
    newOptions.plotOptions = {
      pie: {
        donut: {
          size: "50%", // Lower percentage = thicker donut
        },
      },
    };

    // Configure dataLabels to show percentages
    newOptions.dataLabels = {
      enabled: true,
      formatter: function (val) {
        return val.toFixed(1) + "%";
      },
    };

    setOptions(newOptions);
  }, [labels, colors]);

  return (
    <div>
      <ApexChart options={options} series={series} type="donut" height={height || 300} />
    </div>
  );
};

export default DonutChart;
